// extracted by mini-css-extract-plugin
module.exports = {"status":"TransactionStatus_status__3w3TF","statusInfoPlate":"TransactionStatus_statusInfoPlate__1IfsQ","invalidationInfo":"TransactionStatus_invalidationInfo__1UGbi"};